


import React, { useEffect, useRef } from "react";
import "./Newsletter.css";

function Newsletter() {
  const formContainerRef = useRef(null);

  useEffect(() => {
  const container = formContainerRef.current;
  if (!container) return;

  const script = document.createElement("script");
  script.async = true;
  script.setAttribute("data-uid", "8616433e56");
  script.src = "https://skylarfountain.kit.com/8616433e56/index.js";

  container.appendChild(script);

  return () => {
    container.innerHTML = "";
  };
}, []);

  return (
    <div className="HomePage">
      <div className="HomePage">
        <div className="HomePage-header">
          <header class="UnderConstruction-header">
            <h1>Newsletter</h1>
          </header>
          <section className="NewsletterPage-content">
            <div ref={formContainerRef} />
          </section>
        </div>
      </div>
    </div>
  );
}

export default Newsletter;